import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import { SupabaseProvider } from "./contexts/SupabaseContext";
import "./styles/index.scss";
import App from "./App";

ReactDOM.render(
  <Provider store={store}>
    <SupabaseProvider>
      <App />
    </SupabaseProvider>
  </Provider>,
  document.getElementById("root")
);
